import Qiniu from './qiniu'

const MEDIA_DOMAIN = 'http://store-media.hunliji.com/'
const UPLOAD_URL = 'https://upload-z1.qbox.me'

const config = {
  video: {
    types: 'flv,mp4,mkv,wmv,avi,mov,rm,rmvb,mpeg', // 支持格式
    title: 'Video files',
    max: '500mb',
    uptoken_url: 'http://test.hunliji.com:8080/api/qiniu/video/uptoken',
    multi_selection: false // 视频不支持多选
  },
  image: {
    types: 'jpg,gif,png,jpeg',
    title: 'Image files',
    max: '100mb',
    uptoken_url: 'https://store.hunliji.com/api/qiniu/image/uptoken',
    multi_selection: true
  }
}

const upload = ({ browseButton, events, param }) => {
  const { region, tokenPath } = param
  return new Qiniu({
    uploadUrl: param.upload_url || UPLOAD_URL,
    tokenPath
  }).uploader({
    runtime: 'html5, flash, html4',
    browse_button: browseButton,
    max_file_size: param.max || config[param.type].max, // 最大文件体积限制
    flash_swf_url: 'js/plupload/Moxie.swf',
    max_retries: 3,
    resize: {
      crop: true
    },
    disableBrowse: true,
    dragdrop: false,
    unique_names: true,
    nulti_selections: false,
    type: param.type, //上传类型，'image' 、 'video'
    filters: {
      mime_types: [
        {
          title: config[param.type].title,
          extensions: param.mime_types || config[param.type].types
        }
      ]
    },
    // chunk_size: '20mb',
    get_new_uptoken: false,
    uptoken_url: param.uptoken_url || config[param.type].uptoken_url,
    config: {
      region: null
    },
    domain: param.domain_url || MEDIA_DOMAIN,
    multi_selection: config[param.type].multi_selection,
    auto_start: true,
    init: {
      FilesAdded(up, file) {
        events.filesAdded && events.filesAdded(up, file)
      },
      BeforeUpload(up, file) {
        events.beforeUpload && events.beforeUpload(up, file)
      },
      FileUploaded(up, file, info) {
        const res = JSON.parse(info)

        events.fileUploaded && events.fileUploaded(up, file, res)
      },
      UploadProgress(up, file) {
        events.uploadProgress && events.uploadProgress(up, file)
      },
      Error(up, err, errTip) {
        events.onError && events.onError(up, err, errTip)
      }
    },
    region,
    tokenPath
  })
}

export default upload
